export enum Role {
  PowerUser = 'power_user',
  Admin = 'admin',
  User = 'user',
  Unknown = 'unknown',
  Anonymous = 'anonymous',
}

export enum PermissionResolver {
  EU = 'EU',
}

export interface RolePayloadForFI {
  test: string
  production: string
}

export enum AppVersion {
  'Unknown' = 'Unknown',
  'EU' = 'EU',
  'Test_EU' = 'Test_EU',
}

export interface FirebaseTokenCustomClaims {
  app: AppVersion
  email: string
  role: Role
  roles: string[]
}
